import { getCostsAnalysis } from "@/api/financialReport";
import { createAnalysisModule } from "./utils/createAnalysisModule";

// Drill-down de Análisis de Costos para un mes específico. El tab Costos lo abre
// al clickear una celda mensual de la tabla de evolución. Comparte shape con
// expensesAnalysis (statement jerárquico + ranking de contrapartes); la única
// diferencia de datos es que el statement de Costos expone `margin` por grupo
// en lugar de `efficiency`. Toda la mecánica vive en createAnalysisModule.
export default createAnalysisModule({
    apiFn: getCostsAnalysis,
    fetchActionName: "fetchCostsAnalysis",
    logPrefix: "[costsAnalysis]",
    errorMessage: "Error al cargar el análisis de costos.",
});
